module.exports = __webpack_public_path__ + "media/images/covers/foundation/Foundation-Programme_banner-f89d2b5aa7bd873d124b73406985ae40.png";